export enum FileType {
  CSV = "CSV",
  IBM_SPSS = "IBM_SPSS"
}